import { Component, computed, inject, input, output } from '@angular/core';
import { webDtos } from '@vectronic/openApi-customer';
import { ConfirmDeleteComponent } from '@vectronic/ui';
import { DialogService } from '@vectronic/util';
import { DatatableComponent } from '../../components/datatable/datatable.component';
import { DatatableColumn, DisplayColumn } from '../../types/datatable-column';
import { DatatableConfig } from '../../types/datatable-configuration';

@Component({
  selector: 'table-notification-table',
  templateUrl: './notification-table.component.html',
  styleUrls: ['./notification-table.component.scss'],
  imports: [DatatableComponent],
})
export class NotificationTableComponent {
  collarId = input<number>();
  rules = input<webDtos.NotificationRule[]>();
  isAtLeastDataManager = input<boolean>();

  deleteRuleNotification = output<webDtos.NotificationRule>();
  addNotification = output();

  private dialogService = inject(DialogService);

  private columns: DatatableColumn<webDtos.NotificationRule>[] = [
    {
      headerName: 'Address',
      fieldName: 'notificationAddressValue',
      columnId: 1,
      ellipsis: true,
    },
    {
      headerName: 'Type',
      fieldName: 'notificationAddressType',
      columnId: 2,
    },
  ];

  displayColumns = computed<DisplayColumn<webDtos.NotificationRule>[]>(() =>
    this.isAtLeastDataManager()
      ? this.columns.map(({ fieldName }) => fieldName)
      : ['notificationAddressValue'],
  );
  datatableConfig = computed<DatatableConfig<webDtos.NotificationRule>>(() => ({
    uniqueId: 'notifications_inventa',
    title: 'Notifications',
    columns: this.columns,
    disablePagination: true,
    disableEditColumns: true,
    disableDragColumns: true,
    headerIconButtons: [
      {
        icon: 'add_alert',
        hoverText: 'Add a new notification',
        doHide: !this.isAtLeastDataManager(),
        onClick: () => this.addNotification.emit(),
      },
    ],
    rowActions: [
      {
        matIcon: 'close',
        label: 'Delete notification',
        doHide: () => !this.isAtLeastDataManager(),
        onClick: (row) => this.onDeleteNotification(row),
        color: 'warn',
      },
    ],
  }));

  onDeleteNotification(row: webDtos.NotificationRule) {
    this.dialogService.open(ConfirmDeleteComponent, {
      data: {
        title: 'Delete notification',
        bodyText: `Are you sure you want to disconnect sending notification to ${row.notificationAddressValue} from collar ${this.collarId()}?`,
      },
      afterConfirm: () => this.deleteRuleNotification.emit(row),
    });
  }
}
